import { Expose, Type } from 'class-transformer';
export enum textAlignEnum {
  Left = 'left',
  Right = 'right',
  Center = 'center',
}
export enum styleEnum {
  Strikethrough = 'STRIKETHROUGH',
  Italic = 'ITALIC',
  Underline = 'UNDERLINE',
  Code = 'CODE',
  Subscript = 'SUBSCRIPT',
  Superscript = 'SUPERSCRIPT',
}
export enum typeEnum {
  HeaderOne = 'header-one',
  HeaderTwo = 'header-two',
  HeaderThree = 'header-three',
  HeaderFour = 'header-four',
  HeaderFive = 'header-five',
  HeaderSix = 'header-six',
  Blockquote = 'blockquote',
  Code = 'code',
  Unstyled = 'unstyled',
  OrderedListItem = 'ordered-list-item',
  UnorderedListItem = 'unordered-list-item',
}

export class TermAndConditionModel {
  content: string;
  @Expose({ name: 'created_at' })
  @Type(() => Date)
  createdAt: Date;
  id: string;
  @Expose({ name: 'is_active' })
  isActive: boolean;
  rank: number;
  @Expose({ name: 'text_checkbox' })
  textCheckbox: string;
  title: string;
}

export class ContentModel {
  blocks: BlockModel[];
  entityMap: EntityMapModel[];
}
export class DataBlockModel {
  textAlign: textAlignEnum;
}
export class BlockModel {
  data: DataBlockModel;
  depth: number;
  entityRanges: EntityRangesModel[];
  inlineStyleRanges: InlineStyleRangesModel[];
  key: string;
  text: string;
  type: typeEnum;
}
export class EntityRangesModel {
  key: number;
  length: number;
  offset: number;
}
export class InlineStyleRangesModel {
  style: styleEnum;
  length: number;
  offset: number;
}

export class EntityMapModel {
  data: DataEntityMapModel;
  mutability: string;
  type: string;
}
export class DataEntityMapModel {
  url: string;
  targetOption: string;
}
